// src/components/CarouselItem.js
import React from 'react';
import './CarouselItem.css';
import { Grid2 } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { normalizarTexto } from './Utils/textUtils'; // Asegúrate de que este archivo exista y exporte las funciones necesarias
const chilinAlergeno = require('../assets/img/chilin-alergeno-mini.png');
const favoritoImg = require('../assets/img/favorito.png');

const CarouselItem = ({ imageSrc, title, time, description, id, timeOfDay, alergico, favorito }) => {
  const navigate = useNavigate();

  const handleViewRecipe = () => {
    const slug = normalizarTexto(title);
    //navigate(`/receta/${id}`, { state: { timeOfDay } });
    navigate(`/recetas/${slug}`, { state: { timeOfDay } });
  };

  return (
    <Grid2 className={`carousel-item-container ${alergico ? 'alergico-border' : favorito ? 'favorito-border' : ''}`}>
        <img src={imageSrc} alt={title} className="carousel-item-image" />
        {alergico ? (
          <img
            src={chilinAlergeno} /* Ruta de tu imagen de 40x40 */
            alt="Alérgico"
            className="alergico-icon"
          />
        ) : favorito ? (
          <img
            src={favoritoImg} /* Ruta de tu imagen de 40x40 */
            alt="Favorito"
            className="favorito-icon"
          />
        ) : (
          <Grid2 />
        )}
      <Grid2 className="carousel-item-box">
        <h3 className="carousel-item-title">{title}</h3>
        <p className="carousel-item-description">{description}</p>
        <div className="buttons-container">
          <button className="time-button">
            <span className="material-icons">schedule</span> {time} min
          </button>
          <button className="play-button" onClick={handleViewRecipe}>
            Ver receta
          </button>
        </div>
      </Grid2>
    </Grid2>
  );
};

export default CarouselItem;
